import React from 'react';
import { motion } from 'framer-motion';
export function Hero() {
  return <section id="inicio" className="relative w-full h-screen min-h-[700px] flex items-center justify-center overflow-hidden" data-id="element-210">
      <div className="absolute inset-0 bg-forest/60 z-10" data-id="element-211" />
      <motion.img initial={{
      scale: 1.05
    }} animate={{
      scale: 1
    }} transition={{
      duration: 10,
      ease: 'easeOut'
    }} src="https://images.unsplash.com/photo-1516026672322-bc52d61a55d5?auto=format&fit=crop&q=80" alt="Bosque aéreo" className="absolute inset-0 w-full h-full object-cover" data-id="element-212" />

      <div className="relative z-20 text-center px-4 max-w-5xl mx-auto mt-16" data-id="element-213">
        <motion.span initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8,
        ease: 'easeOut'
      }} className="block text-bone/90 uppercase tracking-[0.2em] text-xs md:text-sm font-semibold mb-6 md:mb-8" data-id="element-214">
          Programa TEFOS · Territorios Forestales Sostenibles
        </motion.span>

        <motion.h1 initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8,
        delay: 0.2,
        ease: 'easeOut'
      }} className="text-5xl md:text-7xl lg:text-8xl font-serif text-bone leading-[1.1] mb-8" data-id="element-215">
          Tejiendo territorio, <br className="hidden md:block" data-id="element-216" /> bosque y
          comunidad
        </motion.h1>

        <motion.p initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8,
        delay: 0.4,
        ease: 'easeOut'
      }} className="text-lg md:text-2xl text-bone/90 max-w-3xl mx-auto font-light leading-relaxed" data-id="element-217">
          Un esfuerzo conjunto para la conservación, el ordenamiento y el
          bienestar de las comunidades locales en Colombia.
        </motion.p>
      </div>
    </section>;
}